<template>
    <div class="outcome w-100 h-100" ref="outcomeChart">
        <svg class="outcome__svg" :class="`outcome__svg--${direction}`" :height="height" :width="width">
            <path
                class="outcome__path"
                :class="`outcome__area--${direction}`"
                stroke="none"
                fill="black"
                stroke-width="2"
                :d="graph.area"
            />
            <path
                class="outcome__path"
                :class="`outcome__path--${direction}`"
                fill="transparent"
                stroke-width="2"
                :d="graph.line"
            />
        </svg>

        <div 
            class="outcome__values h-100 d-flex justify-content-between"
            :class="isUp ? 'flex-column' : 'flex-column-reverse'"
        >
            <div
                v-if="finalValue"
                class="outcome__final ml-2 ml-lg-3"
                :class="isUp ? 'mt-3' : 'mb-3'"
            >
                <div class="outcome__final-text">
                    {{ finalValueText }}
                </div>
                <div class="outcome__final-value">
                    {{ finalValue }}
                </div>
            </div>
            <div v-else />
            <div
                class="outcome__difference d-flex justify-content-end mr-2 mr-lg-3 py-lg-1"
                :class="`outcome__difference--${direction}`"
            >
                <div class="outcome__difference-value mr-1">
                    {{ sign }} {{ difference }}
                </div>
                <div class="outcome__value-icon d-flex align-items-center">
                    <img :src="icon" width="18"/>
                
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ASSETS_URL } from '@/constants/misc'
import { line, area, scaleLinear } from 'd3'

export default {
    name: 'outcome',
    props: {
        finalValueText: {
            type: String
        },
        finalValue: {
            type: String
        },
        difference: {
            type: String
        },
        direction: {
            type: String,
            default: 'up'
        },
        resize: {
            // used to communicate resize from parent
            // mostly for when option is selected and parent gets scaled up
            // where we have no resize on the window but the parent itself
        }
    },
    data() {
        return {
            width: 0,
            height: 0,
        }
    },
    watch: {
        resize() {
            this.onResize()
        }
    },
    computed: {
        isUp() {
            return this.direction === 'up'
        },
        sign() {
            return this.isUp ? '+' : '-'
        },
        icon() {
            return this.isUp ? `${ASSETS_URL}interactions/arrow-up_green.svg` : `${ASSETS_URL}interactions/arrow-down_red.svg`
        },
        graph() {
            let x = scaleLinear()
                .domain([0, 100])
                .range([0, this.width])
            let y = scaleLinear()
                .domain([0, 100])
                .range([this.height, 0])

            // TODO: how to calculate graph
            const valsPos = [[0, 40],[10, 25],[20, 45],[30, 50],[40, 55],[50, 65],[60, 55],[70,50],[80,65],[90,65],[100,95]]
            const valsNeg = valsPos.map((val, i) => [val[0], 100 - (val[1]+i*2)*0.7])

            const line1 = line()
                .x(d => x(d[0]))
                .y(d => y(d[1]))(this.isUp ? valsPos : valsNeg);

            const area1 = area()
                .x(d => x(d[0]))
                .y1(d => y(d[1]))
                .y0(() => this.isUp ? this.height : 0)(this.isUp ? valsPos : valsNeg);

            return {
                line: line1,
                area: area1
            }
        },
    },
    methods: {
        onResize() {
            this.width = this.$refs.outcomeChart.clientWidth;
            this.height = this.$refs.outcomeChart.clientHeight;
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.onResize()

        this.$nextTick(this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }
}
</script>
<style lang="scss">
    .outcome__path {
        stroke-opacity: 0.3;
    }

    .outcome__path--up {
        stroke: $bq-green;
    }

    .outcome__path--down {
        stroke: $bq-red;
    }

    .outcome__area--up {
        fill: $bq-green;
        fill-opacity: 0.075;
    }

    .outcome__area--down {
        fill: $bq-red;
        fill-opacity: 0.075;
    }

    .outcome__difference {
        font-weight: bold;
        @media screen and (min-width: 992px) {
            font-size: 1.1rem;
        }
    }

    .outcome__difference--up {
        color: $bq-green;
    }

    .outcome__difference--down {
        color: $bq-red;
    }

    .outcome__svg {
        position: absolute;
    }

    .outcome__svg--down {
        border-radius: 0 0 1em 1em;
    }

    .outcome__final-text {
        font-size: 0.825em;
    }

    .outcome__values {
        @media screen and (min-width: 992px) {
            font-size: 1.1rem;
        }
    }

    .outcome__final {
        font-weight: 600;
    }

    .outcome__final-value {
        color: $main-font-grey;
    }
</style>